module.exports = __webpack_public_path__ + "static/media/takePhotoButton.33afb87f.svg";